var Tool = {
    addEventHandler: (target, type, fn) => {
        if (target.addEventListener) {
            target.addEventListener(type, fn);
        } else {
            target.attachEvent('on' + type, fn);
        }
    },
    removeEventHandler: (target, type, fn) => {
        if (target.removeEventListener) {
            target.removeEventListener(type, fn);
        } else {
            target.detachEvent('on' + type, fn);
        }
    },

    dateFormat_new: (second_obj, second_now) => {
        if (!second_now) {
            second_now = Math.round(new Date().getTime() / 1000)
        }

        var time_sub = second_now - second_obj; //时间差

        var year_time = 365 * 24 * 60 * 60;
        var month_time = 30 * 24 * 60 * 60;
        var day_time = 24 * 60 * 60;
        var hour_time = 60 * 60;
        var min_time = 60;


        var year = Math.floor(time_sub / year_time);
        var month = Math.floor((time_sub - year * year_time) / month_time);
        var day = Math.floor((time_sub - year * year_time - month * month_time) / day_time);
        var hour = Math.floor((time_sub - year * year_time - month * month_time - day * day_time) / hour_time);
        var min = Math.floor((time_sub - year * year_time - month * month_time - day * day_time - hour * hour_time) / min_time);

        return year > 0 ? (year + "年之前") : (month > 0 ? (month + "月之前") : (day > 0 ? (day + "天之前") : (hour > 0 ? (hour + "小时之前") : (min > 0 ? (min + "分钟之前") : "刚刚"))))
    },
    isIOS: () => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            return true
        } else {
            return false
        }

    },
    isAndroid: () => {
        if (/(Android)/i.test(navigator.userAgent)) {
            return true;
        } else {
            return false
        }
    },
    isWeiXin: () => {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) === 'micromessenger') {
            return true;
        } else {
            return false;
        }
    },
    // 获取页面中url参数
    getParams: function (url) {
      if (!url) {
        url = window.location.hash;
      }
      const theRequest = {};
      const start = url.indexOf("?");
      if (start !== -1) {
        const str = url.substr(start + 1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    // 转换时间格式为xx天前
    dateStr: function (date) {
      //获取js 时间戳
      var time = new Date().getTime();
      // 后台返回的时间戳是秒，不是毫秒
      time = parseInt(time/1000)-date ;
      //存储转换值
      var s;
      // if (time < 60 * 10) {//十分钟内
      //   return '刚刚';
      // } else 
      if ((time < 60 * 60)) {
        //少于1小时
        s = Math.floor(time / 60);
        return s + "分钟前";
      } else if ((time < 60 * 60 * 24)) {
        //超过1小时少于24小时
        s = Math.floor(time / 60 / 60);
        return s + "小时前";
      } else if ((time < 60 * 60 * 24 * 2) && (time >= 60 * 60 * 24)) {
        //超过1天少于2天内
        s = Math.floor(time / 60 / 60 / 24);
        return s + "天前";
      } else {
        //超过2天
        var d = new Date(parseInt(date*1000));

        var year = d.getFullYear();
        var month = change(d.getMonth() + 1);
        var day = change(d.getDate());
        function change(t) {
          if (t < 10) {
            return "0" + t;
          } else {
            return t;
          }
        }
        var newTime = year + '-' + month + '-' + day;
        return newTime;
      }
    },
}

export default Tool;


// WEBPACK FOOTER //
// ./src/utils/tool.js